import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    minHeight: '100vh',
    padding: theme.spacing(4),
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.bg.main,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 500,
    lineHeight: theme.spacing(4),
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  statusError: {
    marginBottom: theme.spacing(2),
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.error.main,
  },
  landing: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(2),
    maxWidth: theme.spacing(90),
    margin: '0 auto',
    padding: theme.spacing(6, 5),
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 2.5),
    },
  },
  landingIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(7),
    height: theme.spacing(7),
    borderRadius: '50%',
    marginBottom: theme.spacing(0.5),
    fontSize: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.bg.main,
  },
  landingTitle: {
    fontSize: theme.spacing(2.75),
    fontWeight: 500,
    lineHeight: theme.spacing(3.5),
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  landingDescription: {
    maxWidth: theme.spacing(70),
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.75),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  landingSteps: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    width: '100%',
    margin: theme.spacing(2, 0, 1),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  landingStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    textAlign: 'left',
    padding: theme.spacing(2.5),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    backgroundColor: theme.palette.bg.main,
  },
  landingStepIcon: {
    fontSize: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  landingStepTitle: {
    fontSize: theme.spacing(1.875),
    fontWeight: 500,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.primary,
  },
  landingStepText: {
    fontSize: theme.spacing(1.625),
    fontWeight: 400,
    lineHeight: theme.spacing(2.25),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  landingFootnote: {
    maxWidth: theme.spacing(65),
    marginTop: theme.spacing(0.5),
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: theme.spacing(2.25),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  emptyTasks: {
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'start',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2.5),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    backgroundColor: theme.palette.common.white,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  cardTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  phaseRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  phaseSpinner: {
    color: theme.palette.labraFormProgress.main,
    flexShrink: 0,
  },
  phaseLabel: {
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.primary,
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  count: {
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
  },
  percent: {
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.labraText.primary,
  },
  progressBar: {
    height: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.dividerV2.main,
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.labraFormProgress.main,
      borderRadius: theme.spacing(0.5),
    },
  },
  progressBarSucceeded: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.listingStatus.main,
    },
  },
  progressBarFailed: {
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.error.main,
    },
  },
  errorText: {
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.error.main,
  },
}))
